import ColorTheme from './models/ColorTheme';

export default function getSystemColorTheme() {
  const hasDarkPreference = globalThis.matchMedia('(prefers-color-scheme: dark)').matches;
  return hasDarkPreference ? ColorTheme.DARK : ColorTheme.LIGHT;
}
